export default [{
  //用车计划编制
  path: 'useCarAdd',
  name: 'useCarAdd',
  component: function component() {
    return import('@/views/tms/transportPlansUse/useCarManage/useCarAdd');
  }
}, {
  //用车计划列表
  path: 'useCarList',
  name: 'useCarList',
  component: function component() {
    return import('@/views/tms/transportPlansUse/useCarManage/useCarList');
  }
}, {
  //料品管理
  path: 'materialsManageLit',
  name: 'materialsManageLit',
  component: function component() {
    return import('@/views/tms/transportPlansUse/useCarManage/materialList');
  }
}, {
  //路线规划
  path: 'linePlan',
  name: 'linePlan',
  component: function component() {
    return import('@/views/tms/transportPlansUse/useCarManage/linePlanList');
  }
}, {
  //路线规划
  path: 'linePlanAdd',
  name: 'linePlanAdd',
  component: function component() {
    return import('@/views/tms/transportPlansUse/useCarManage/linePlanAdd');
  }
}, {
  //派车计划编辑
  path: 'scheduleCarAdd',
  name: 'scheduleCarAdd',
  component: function component() {
    return import('@/views/tms/transportPlansUse/scheduleCarManage/scheduleCarAdd');
  }
}, {
  //派车计划列表
  path: 'scheduleCarList',
  name: 'scheduleCarList',
  component: function component() {
    return import('@/views/tms/transportPlansUse/scheduleCarManage/scheduleCarList');
  }
}, {
  //进场设备登记
  path: 'goIndeviceEnroll',
  name: 'goIndeviceEnroll',
  component: function component() {
    return import('@/views/tms/transportPlansUse/goInDeviceManage/add');
  }
}, {
  //进场设备清单
  path: 'goInDeviceList',
  name: 'goInDeviceList',
  component: function component() {
    return import('@/views/tms/transportPlansUse/goInDeviceManage/list');
  }
}, {
  //待办
  path: 'dispatchTransportPlanAdd',
  name: 'dispatchTransportPlanAdd',
  component: function component() {
    return import('@/views/tms/transportPlansUse/scheduleCarManage/PlanAdd');
  }
}];